// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/home/hero-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-found-page {
  width: 100%;
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
  color: #445169;
  line-height: 120%;
}
.not-found-page a {
  color: #445169;
  text-decoration: none;
}
.not-found-page .not-found-page-hero {
  width: 100%;
  min-height: 570px;
  border: 1px solid rgb(222, 225, 231);
  background-color: #040e46;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  border-radius: 20px;
  margin-top: 22px;
  display: flex;
  position: relative;
}
.not-found-page .not-found-page-hero .left-block {
  flex: 1 1;
}
.not-found-page .not-found-page-hero .left-block img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.not-found-page .not-found-page-hero .center-block {
  height: 570px;
}
.not-found-page .not-found-page-hero .center-block .center-block-circle-img {
  background-color: #fff;
  border-radius: 50%;
  height: 620px;
  width: 620px;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.not-found-page .not-found-page-hero .center-block .center-block-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 420px;
}
.not-found-page .not-found-page-hero .center-block .center-block-content .not-found-number-title {
  font-size: 22px;
  font-weight: 400;
  line-height: 180%;
  color: #448aff;
}
.not-found-page .not-found-page-hero .center-block .center-block-content .not-found-title {
  font-weight: 600;
  font-size: 46px;
  line-height: 120%;
  margin-top: 24px;
  color: #000;
}
.not-found-page .not-found-page-hero .center-block .center-block-content .not-found-title .blue-part {
  color: #448aff;
}
.not-found-page .not-found-page-hero .center-block .center-block-content .not-found-subtitle {
  color: #448aff;
  margin-top: 24px;
  font-weight: 400;
  font-size: 22px;
  line-height: 180%;
}
.not-found-page .not-found-page-hero .center-block .center-block-content .return-home-btn {
  background-color: #3571d6;
  width: 176px;
  display: inline-flex;
  align-items: center;
  margin-top: 48px;
  justify-content: center;
  height: 42px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  border: none;
  gap: 8px;
  border-bottom: 2px solid #040e46;
  box-shadow: 0px 18px 32px -4px rgba(15, 23, 40, 0.22), 0px 6px 10px -4px rgba(15, 23, 40, 0.1);
}
.not-found-page .not-found-page-hero .center-block .center-block-content .return-home-btn svg {
  vertical-align: middle;
}
.not-found-page .not-found-page-hero .right-block {
  flex: 1 1;
}
.not-found-page .not-found-page-hero .right-block img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.not-found-page.isMobile .home-page-content .left-block {
  display: none;
}
.not-found-page.isMobile .home-page-content .not-found-page-hero .center-block {
  width: 100%;
  overflow-x: hidden;
}
.not-found-page.isMobile .home-page-content .not-found-page-hero .center-block .center-block-circle-img {
  height: 450px;
  width: 450px;
}
.not-found-page.isMobile .home-page-content .not-found-page-hero .center-block .center-block-content {
  padding: 20px;
}
.not-found-page.isMobile .home-page-content .not-found-page-hero .center-block .center-block-content .not-found-number-title {
  font-size: 20px;
}
.not-found-page.isMobile .home-page-content .not-found-page-hero .center-block .center-block-content .not-found-title {
  font-size: 32px;
}
.not-found-page.isMobile .home-page-content .not-found-page-hero .center-block .center-block-content .not-found-subtitle {
  font-size: 22px;
}
.not-found-page.isMobile .home-page-content .not-found-page-hero .right-block {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/not-found/styles.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AADF;AAGE;EACE,cAAA;EACA,qBAAA;AADJ;AAIE;EACE,WAAA;EACA,iBAAA;EACA,oCAAA;EACA,yBAAA;EACA,yDAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AAFJ;AAII;EACE,SAAA;AAFN;AAIM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAFR;AAMI;EACE,aAAA;AAJN;AAMM;EACE,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAJR;AAOM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;AALR;AAOQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AALV;AAQQ;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AANV;AAQU;EACE,cAAA;AANZ;AAUQ;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AARV;AAWQ;EACE,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,gCAAA;EACA,8FACE;AAVZ;AAaU;EACE,sBAAA;AAXZ;AAiBI;EACE,SAAA;AAfN;AAiBM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAfR;;AAuBI;EACE,aAAA;AApBN;AAwBM;EACE,WAAA;EACA,kBAAA;AAtBR;AAwBQ;EACE,aAAA;EACA,YAAA;AAtBV;AAyBQ;EACE,aAAA;AAvBV;AAyBU;EACE,eAAA;AAvBZ;AA0BU;EACE,eAAA;AAxBZ;AA2BU;EACE,eAAA;AAzBZ;AA8BM;EACE,aAAA;AA5BR","sourcesContent":["$grey: #445169;\n\n.not-found-page {\n  width: 100%;\n  max-width: 1440px;\n  margin-left: auto;\n  margin-right: auto;\n  color: #445169;\n  line-height: 120%;\n\n  a {\n    color: #445169;\n    text-decoration: none;\n  }\n\n  .not-found-page-hero {\n    width: 100%;\n    min-height: 570px;\n    border: 1px solid rgba(222, 225, 231, 1);\n    background-color: #040e46;\n    background-image: url('../../assets/images/home/hero-bg.png');\n    background-size: cover;\n    border-radius: 20px;\n    margin-top: 22px;\n    display: flex;\n    position: relative;\n\n    .left-block {\n      flex: 1 1 0;\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n\n    .center-block {\n      height: 570px;\n\n      .center-block-circle-img {\n        background-color: #fff;\n        border-radius: 50%;\n        height: 620px;\n        width: 620px;\n        position: relative;\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n      }\n\n      .center-block-content {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        text-align: center;\n        width: 420px;\n\n        .not-found-number-title {\n          font-size: 22px;\n          font-weight: 400;\n          line-height: 180%;\n          color: #448aff;\n        }\n\n        .not-found-title {\n          font-weight: 600;\n          font-size: 46px;\n          line-height: 120%;\n          margin-top: 24px;\n          color: #000;\n\n          .blue-part {\n            color: #448aff;\n          }\n        }\n\n        .not-found-subtitle {\n          color: #448aff;\n          margin-top: 24px;\n          font-weight: 400;\n          font-size: 22px;\n          line-height: 180%;\n        }\n\n        .return-home-btn {\n          background-color: #3571d6;\n          width: 176px;\n          display: inline-flex;\n          align-items: center;\n          margin-top: 48px;\n          justify-content: center;\n          height: 42px;\n          border-radius: 8px;\n          font-size: 14px;\n          font-weight: 600;\n          color: #fff;\n          border: none;\n          gap: 8px;\n          border-bottom: 2px solid #040e46;\n          box-shadow:\n            0px 18px 32px -4px rgba(15, 23, 40, 0.22),\n            0px 6px 10px -4px rgba(15, 23, 40, 0.1);\n\n          svg {\n            vertical-align: middle;\n          }\n        }\n      }\n    }\n\n    .right-block {\n      flex: 1 1 0;\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n  }\n}\n\n.not-found-page.isMobile {\n  .home-page-content {\n    .left-block {\n      display: none;\n    }\n\n    .not-found-page-hero {\n      .center-block {\n        width: 100%;\n        overflow-x: hidden;\n\n        .center-block-circle-img {\n          height: 450px;\n          width: 450px;\n        }\n\n        .center-block-content {\n          padding: 20px;\n\n          .not-found-number-title {\n            font-size: 20px;\n          }\n\n          .not-found-title {\n            font-size: 32px;\n          }\n\n          .not-found-subtitle {\n            font-size: 22px;\n          }\n        }\n      }\n\n      .right-block {\n        display: none;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
